// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:07:34

export default {
  "id": "boolu-bask",
  "slug": "boolu-bask",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3f74a38ee3e7481c8edde3d78f6c08b9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3f74a38ee3e7481c8edde3d78f6c08b9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Boolu Bask",
      "description": "Dunk Ball game is an exciting sports-based game that brings the thrills of basketball right to your device. The focus of the game is on scoring points by aiming each ball into the moving basket. Show off your agility, precision, and timing as you handle each ball with finesse and drop them into the basket for maximum points.",
      "instructions": "To play Dunk Ball, simply move your basket left or right to catch the ball as it descends from above. It requires sharp reflexes and strategy to ensure each ball falls perfectly into the basket. As you progress, the game's tempo increases, demanding more skill, attention, and faster reactions for scoring.",
      "genres": [
        "Basketball"
      ],
      "tags": [
        "baseball",
        "basket",
        "parking",
        "physics",
        "target"
      ]
    },
    "zh-CN": {
      "title": "布尔布斯克",
      "description": "灌篮球游戏是一款激动人心的以体育为主题的游戏，将篮球的刺激体验直接带到您的设备上。游戏的重点是通过瞄准移动篮筐将每一球投入得分。在巧妙地处理每一球并将其投入篮筐以获得最高分的过程中，展示您的敏捷性、精确性和时机。",
      "instructions": "玩Dunk Ball，只需左右移动篮筐来捕捉从上方下落的球。这需要敏捷的反应和策略，以确保每个球都能完美地落入篮筐。随着游戏的进行，游戏节奏加快，要求玩家具备更高的技巧、专注度和更快的反应速度以得分。",
      "genres": [
        "篮球"
      ],
      "tags": [
        "棒球",
        "篮球",
        "停车",
        "物理",
        "目标"
      ]
    },
    "zh-TW": {
      "title": "Boolu Bask",
      "description": "dunk Ball 遊戲是一款刺激的體育基礎遊戲，將籃球的驚險刺激帶到您的設備上。遊戲的重點是通過將每個球投向移動的籃筐來得分。在處理每個球時展現您的靈活性、精準度和時間感，將球輕輕投入籃筐以獲得最高分數。",
      "instructions": "要玩 Dunk Ball，只需將籃框左右移動來捕捉從上方下降的球。這需要敏捷的反應和策略，確保每個球都能完美落入籃框。隨著進度增加，遊戲的節奏會加快，需要更高的技巧、注意力以及更快的反應來得分。",
      "genres": [
        "籃球"
      ],
      "tags": [
        "棒球",
        "籃球",
        "停車場",
        "物理",
        "目標"
      ]
    },
    "zh-HK": {
      "title": "波魯籃球",
      "description": "Dunk Ball遊戲是一款充滿刺激的體育遊戲，將籃球比賽的刺激感帶到你的設備上。遊戲的重點在於通過將每個球投入移動的籃筐來得分。在處理每個球時展現你的敏捷性、精準度和時機，將它們投入籃筐以獲得最高分數。",
      "instructions": "玩搗波波，簡單地左右移動籃子，當波波從上方降下時接住它。這需要靈敏的反應和策略，以確保每顆波波完美地落入籃子中。隨著進展，遊戲的速度增加，需要更高的技巧、注意力和更快的反應來得分。",
      "genres": [
        "籃球"
      ],
      "tags": [
        "棒球",
        "籃球",
        "停車場",
        "物理學",
        "目標"
      ]
    },
    "ja": {
      "title": "ボールバスカ",
      "description": "ダンクボールゲームは、バスケットボールのスリルをデバイスに持ち込む興味深いスポーツゲームです。ゲームの焦点は、動くバスケットにボールを狙って得点することにあります。それぞれのボールを巧みに扱い、スコアを最大化するためにバスケットに落とすことで、あなたの敏捷性、精度、タイミングを披露してください。",
      "instructions": "ダンクボールを遊ぶには、単にバスケットを左右に動かして、上から落ちてくるボールをキャッチするだけです。ボールがバスケットに完璧に落ちるために、鋭い反応と戦略が必要です。進むにつれて、ゲームのテンポが速くなり、スコアリングするためにさらにスキル、注意力和速い反応が必要になります。",
      "genres": [
        "バスケットボール"
      ],
      "tags": [
        "野球",
        "バスケット",
        "駐車場",
        "物理",
        "ターゲット"
      ]
    },
    "ko": {
      "title": "볼루 배스크",
      "description": "도넛볼 게임은 놀라운 스포츠 기반 게임으로, 농구의 흥분을 디바이스로 바로 가져오는 게임입니다. 게임의 중점은 이동하는 바스켓에 각 공을 맞추어 점수를 득점하는 것입니다. 각 공을 정교하게 다루고 바스켓에 넣어 최대 점수를 득점하면서 자신의 유연성, 정밀성, 시간 조절을 자랑하세요.",
      "instructions": "Dunk Ball을 플레이하려면 단순히 공이 위에서 내려오는 동안 캐스트를 왼쪽이나 오른쪽으로 이동하여 잡아야 합니다. 각 공이 바스켓에 완벽하게落下하도록하기 위해서는 뛰어난 반응 속도와 전략이 필요합니다. 진행함에 따라 게임의 템포가 증가하며, 스코어를 위해 더 많은 기술, 주의와 빠른 반응이 필요합니다.",
      "genres": [
        "농구"
      ],
      "tags": [
        "야구",
        "농구",
        "주차",
        "물리학",
        "타겟"
      ]
    },
    "fr": {
      "title": "Boolu Bask",
      "description": "Le jeu Dunk Ball est un jeu sportif passionnant qui apporte les émotions du basket directement sur votre appareil. L'objectif du jeu est de marquer des points en visant chaque balle dans le panier en mouvement. Montrez votre agilité, précision et timing en maniant chaque balle avec grâce et en les glissant dans le panier pour des points maximums.",
      "instructions": "Pour jouer au Dunk Ball, déplacez simplement votre panier à gauche ou à droite pour attraper la balle alors qu'elle descend du haut. Cela nécessite une agilité et une stratégie aiguë pour assurer que chaque balle tombe parfaitement dans le panier. Au fur et à mesure que vous progressez, le rythme du jeu s'accélère, exigeant plus de compétence, d'attention et de réactions rapides pour marquer des points.",
      "genres": [
        "Basketball : Basket-ball"
      ],
      "tags": [
        "baseball",
        "basket",
        "stationnement",
        "physique",
        "cible"
      ]
    }
  }
};
